import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-ratings',
  templateUrl: './ratings.component.html',
  styleUrls: ['./ratings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RatingsComponent implements OnInit {

  @Input() imdbId: string = "";
  @Input() tomatoesUrl: string;
  @Input() metacriticUrl: string;
  @Input() letterboxdUrl: string;
  @Input() useCompactLayout: boolean = true;
  @Input() imdbRating;
  @Input() tomatoesRating;
  @Input() metacriticRating;
  @Input() letterboxdRating;

  constructor() { }

  ngOnInit() {
  }

  getTomatoesIcon(): string {

    if(this.tomatoesRating > 74) {
      return "./assets/images/rotten_certified.png";
    }
    else if(this.tomatoesRating > 59){
      return "./assets/images/rotten_fresh.png";
    }
    else {
      return "./assets/images/rotten_rotten.png";
    }

  }

  getImdbLink(): string {
    return 'https://www.imdb.com/title/' + this.imdbId;
  }

  getMetacriticColor(): string {

    if(this.metacriticRating > 60) {
      return "metacritic-green";
    }
    else if(this.metacriticRating > 39){
      return "metacritic-yellow";
    }
    else {
      return "metacritic-red";
    }

  }

  formatImDBRating(rating: number) {
    return rating.toFixed(1);
  }

  formatLetterboxdRating(rating: number) {
    return rating.toFixed(1);
  }

}
